<template>
  <v-row>
    <v-col cols="12">
      <div>
        <strong>{{ $t('surveys.notifications') }}<span class="red--text">*</span></strong>
        <div class="caption">
          {{ $t('surveys.notifications_explained') }}
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <v-row justify="start" no-gutters>
        <v-btn-toggle :value="survey.notifications" mandatory @change="v => {
          if(survey.notifications !== v) $emit('change', v)
        }">
          <v-btn :disabled="!$hasMatchingTenantRoles(['tenant_admin'])" :small="$vuetify.breakpoint.smAndDown"
                 :value="null">
            {{ $t('surveys.notification_types.off') }}
          </v-btn>
          <v-btn :disabled="!$hasMatchingTenantRoles(['tenant_admin'])" :small="$vuetify.breakpoint.smAndDown"
                 value="DAILY">
            {{ $t('surveys.notification_types.daily') }}
          </v-btn>
          <v-btn :disabled="!$hasMatchingTenantRoles(['tenant_admin'])" :small="$vuetify.breakpoint.smAndDown"
                 value="WEEKLY">
            {{ $t('surveys.notification_types.weekly') }}
          </v-btn>
        </v-btn-toggle>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SurveyNotificationSelect",
  props: {
    survey: {
      type: Object,
      required: true,
    },
  }
}
</script>

<style scoped>

</style>
